import {PaletteMode} from '@mui/material';
import {createContext, useContext} from 'react';
import {TLatLng, LiveFoundObject} from '@context/MapContext';

type ContextType = {
	theme: PaletteMode,
	setTheme: (theme: PaletteMode) => void,
	setFontSize: (size: number) => void,
	liveLocation: TLatLng | null,
	setLiveLocation: (_value: TLatLng) => void,
	liveFound: LiveFoundObject,
	setLiveFound: (_value: LiveFoundObject) => void,
	shahadat: boolean,
};

const ProjectContext = createContext<ContextType>({
	theme: 'light',
	setTheme: (theme: PaletteMode) => {
	},
	setFontSize: (size: number) => {
	},
	liveLocation: {lat: 36.2884, lng: 59.6157}, //ImamReza Shrine Lat,Lng
	setLiveLocation: (_value: TLatLng) => {
	},
	liveFound: LiveFoundObject.NotFound,
	setLiveFound: (_value: LiveFoundObject) => {
	},
	shahadat: true
});
const useProjectContext = () => useContext(ProjectContext);

export {
	ProjectContext,
	useProjectContext
};
